<template lang="pug">
v-flex 
  v-card
    v-card-title Clientes
      v-spacer
      v-text-field(v-model='search' append-icon='fa-search' label='Buscar clientes' single-line hide-details)
      v-dialog(v-model='Clients.dialog' max-width='500px')
        template(v-slot:activator='{ on }')
          v-btn.mb-2(color='primary' dark v-on='on' @click='clearForm()') Añadir
        v-card
          v-card-title {{ title }}
          v-card-text
            v-col
              v-row
                v-col
                  v-text-field(v-model='Datos.name' label='Nombre')
              v-row
                v-col
                  v-autocomplete(label='Tipo de documento' v-model='Datos.documenType' :items='documentTypesRecord' item-text='description' return-object)
              v-row
                v-col
                  v-text-field(v-model='Datos.document' label='Número')
                v-col
                  v-text-field(v-model='Datos.phone' label='Telefono')
              v-row
                v-col
                  v-text-field(v-model='Datos.email' label='E-mail')
              v-row
                v-col
                  v-text-field(v-model='dirección.ubicación' label='Dirección')
              v-row(align='center')
                v-col
                  MinicrudCombobox( @resultado="val => dirección.departamento = val" arreglo='Departamento' :requiere_codigo='true')
                v-col
                  MinicrudCombobox( @resultado="val => dirección.provincia = val" arreglo='Provincia' :requiere_codigo='true')
                v-col
                  MinicrudCombobox( @resultado="val => dirección.distrito = val" arreglo='Distrito' :requiere_codigo='true')
                v-col
                  v-btn(small rounded @click='agregar_dirección(dirección)' color='primary' ) 
                    v-icon(small) fas fa-plus
              v-row  
                v-list
                  v-subheader Direcciones
                  template(v-for='dirección in Datos.direcciones')
                    v-list-item
                      v-list-item-content 
                        v-list-item-title( v-text='dirección.ubicación' )
                        v-list-item-subtitle( v-text='dirección.ubigeo' ) 
                      v-list-item-action( )
                        v-icon(color='primary' @click='eliminar_dirección(dirección)' small ) far fa-trash-alt
          v-card-actions
            v-spacer
            v-btn(color='primary' @click='save()') {{ titleButton }}
    v-data-table.elevation-1(:headers='headers' :items='ClientsRecord' :search='search')
      template(v-slot:item.action='{item}')
        v-btn(color='secondary' icon @click='editItem(item.key)')
          v-icon(small) far fa-edit
        v-btn(color='secondary' icon @click='deleteItem(item.key)')
          v-icon(small) far fa-trash-alt
      template(v-slot:item.direcciones='{item}')
        v-chip(color='primary' v-if='item.direcciones') {{item.direcciones.length}}
</template>

<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
  data: () => ({
    search: '',
    dirección: {
      ubicación: '',
      ubigeo: '',
      distrito: '',
      provincia: '',
      departamento: '',
    },
    headers: [
      {
        text: 'Lista de Trabajadores',
        align: 'left',
        value: 'name'
      },
      { text: 'Documento', value: 'document' },
      { text: 'Telefono', value: 'phone' },
      { text: 'E-mail', value: 'email' },
      { text: 'Direcciones', value: 'direcciones' },
      { text: 'Fecha de creación', value: 'createdAt' },
      { text: '', value: 'action', sortable: false }
    ],
  }),
    methods: {
      ...mapActions({
        editItem: 'Clients/get',
        deleteItem: 'Clients/clean',
        save: 'Clients/add',
        clearForm: 'Clients/clearForm',
      }),
      agregar_dirección(dirección){
        if(!this.Datos.direcciones) this.Datos.direcciones = []
        this.Datos.direcciones.push({
          ubicación: `${dirección.ubicación} ${dirección.distrito.descripcion} ${dirección.provincia.descripcion} ${dirección.departamento.descripcion}`, 
          ubigeo: `${dirección.departamento.codigo}${dirección.provincia.codigo}${dirección.distrito.codigo}`
        })
        this.dirección.ubicación = ''
      },
      eliminar_dirección(dirección){
        this.Datos.direcciones.splice( this.Datos.direcciones.indexOf( dirección ), 1)
      }
    },
    computed: {
      title() { return this.Clients.selectedKey == '' ? 'Registar' : 'Crear' },
      titleButton() { return this.Clients.selectedKey == "" ? 'Guardar' : 'Editar' },
      ...mapGetters({
        ClientsRecord: 'Clients/record',
        workerTypeRecord: 'UserType/recordTypeRole',
        documentTypesRecord: 'DocumentTypes/record'
      }),
      ...mapState({
      Datos: state=> state.Clients.data,
      Clients :state=> state.Clients,
    })
  },
  components: {
    MinicrudCombobox : ()=>import('@/components/minicrud_combobox')
  }
}
</script>
